<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="仪器名称">
                    <el-input v-model.trim="filters.instrumentName" clearable placeholder="请输入仪器名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="仪器规范名称">
                    <el-input v-model.trim="filters.canonicalName" clearable placeholder="请输入规范名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="仪器打印名称">
                    <el-input v-model.trim="filters.printName" clearable placeholder="请输入打印名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="instrumentName" label="仪器名称"></el-table-column>
                <el-table-column sortable prop="canonicalName" label="规范名称"></el-table-column>
                <el-table-column sortable prop="printName" label="打印名称"></el-table-column>
                <el-table-column sortable prop="projectName" label="项目"></el-table-column>
                <el-table-column prop="printProjectName" label="打印项目"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" width="100" label="添加时间"></el-table-column>
                <el-table-column align="center" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">选择项目</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 诊断列表弹框 -->
        <el-dialog center title="请选择项目" :visible.sync="dialogForm">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item>
                    <el-checkbox-group class="cardName" size="medium" v-model="form.printProjectName">
                        <el-checkbox style="display:block;" v-for="(item) in loadOptions" :key="item.id" :label="item.project">
                            <span>{{item.project}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <div class="flex">
                    <el-button @click="dialogForm = false">取消</el-button>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, } from 'vuex'

export default {
    name: "skin",
    computed: {
        ...mapState(['areaOptions']),
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                departmentName: '',
            },
            tableData: [],
            multipleSelection: [],
            tableHeight: '',
            dialogForm: false,
            loadOptions: [],
            form: {},
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            let path = this.$route.fullPath
            if (path == '/skin/skin1') {

            } else if (path == '/skin/skin2') {

            } else if (path == '/skin/skin3') {

            }
            this.query(this.filters.pagination.page);
        },
    },
    methods: {
        handleEdit(idnex, row) {
            this.form = JSON.parse(JSON.stringify(row))
            if (this.form.printProjectName && this.form.printProjectName != '') {
                this.form.printProjectName = _g.turnNum(this.form.printProjectName.split(','))
            } else if (this.form.printProjectName == '' || this.form.printProjectName == null) {
                this.form.printProjectName = []
            }
            api.request('/menu/findInstrumentMenuByIdProjectList', {
                id: row.id,
            }, (res) => {
                // console.log(res)
                if (res.result == true) {
                    let data = res.data
                    this.loadOptions = data.projectList
                    this.form.printProjectName = []
                    if (this.loadOptions.length != 0) {
                        this.dialogForm = true
                    } else if (this.loadOptions.length == 0) {
                        _g.toast("error", '暂无项目数据');
                    }
                    // 项目回显数据转换
                    data.projectList.forEach(item => {
                        data.isPrint.forEach(ele => {
                            if (item.id == ele) {
                                this.form.printProjectName.push(item.project)
                            }
                        });
                    });
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { })
        },
        onSubmit() {
            console.log(this.form);
            this.form.isPrint = []
            this.loadOptions.forEach(item => {
                this.form.printProjectName.forEach(ele => {
                    if (item.project == ele) {
                        this.form.isPrint.push(item.id)
                    }
                });
            });
            console.log(this.form.isPrint);
            let data = {
                id: this.form.id,
                isPrint: this.form.isPrint.toString(),
                // isPrint: this.form.isPrint.toString()
            }
            api.request('/menu/updateInstrumentMenuIsPrint', data, (res) => {
                // console.log(res)
                if (res.result == true) {
                    _g.toast("success", "项目修改成功");
                    this.dialogForm = false
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { })
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        printChange(index, row) {
            let data = {
                id: row.id
                // 0：正常 1：禁用
            }
            api.request("/menu/updateInstrumentMenuIsPrint", data, (res) => {
                if (res.result == true) {
                    _g.toast("success", "状态修改成功")
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", "状态修改失败")
                    this.query(this.filters.pagination.page)
                }
            })
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                instrumentName: this.filters.instrumentName,
                canonicalName: this.filters.canonicalName,
                printName: this.filters.printName,
                areaId: this.filters.areaId,
                departmentCode: '001',
                equipment: this.filters.equipment
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            api.request('/menu/findInstrumentMenuByCodePage', querys, (res) => {
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}
</style>